import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Unprotected } from '@auth-util-lib/auth.model'
import { DashboardRedirectGuard } from '@auth-util-lib/guards/dashboard-redirect.guard'
import { AppRoute } from '@auth-util-lib/routing.model'
import { LandingPageComponent } from '@landing-page/landing-page.component'
import { DemoRequestComponent } from '@landing-page/sign-up/demo-request/demo-request.component'
import { LandingPageSignUpComponent } from '@landing-page/sign-up/landing-page-sign-up.component'
import { LandingPageFooterComponent } from '@platform-lib/components/footer/landing-page-footer/landing-page-footer.component'
import { LandingPageTopBarComponent } from '@platform-lib/components/header/landing-page-top-bar/landing-page-top-bar.component'
import { IncompatibleBrowserGuard } from '@platform-lib/guards/incompatible-browser-guard'

const routes: AppRoute[] = [
    {
        canActivate: [DashboardRedirectGuard, IncompatibleBrowserGuard],
        component: LandingPageComponent,
        data: {
            title: 'LandingPageTitle',
            metaDescription:
                'VTG’s rail freight and logistics platform with digital tools like wagon tracking, Fleet Management, ETA and others to strengthen the railway business.',
            metaKeywords:
                'VTG digital products,VTG platform,Rail sector,Performance,Fleet management,Analytics,Rail freight,Logistics,Digital tools,Wagon,Railcar,Tracking,ETA,Predictive Maintenance,Workshop Management',
            fullWidth: true,
            headerComponent: LandingPageTopBarComponent,
            headerClass: 'landing-page-header',
            footerComponent: LandingPageFooterComponent,
            protection: Unprotected,
            optimizedForMobile: true,
        },
        path: '',
    },
    {
        canActivate: [IncompatibleBrowserGuard],
        component: LandingPageSignUpComponent,
        data: {
            title: 'Sign Up',
            fullWidth: true,
            headerComponent: LandingPageTopBarComponent,
            headerClass: 'landing-page-header',
            footerComponent: LandingPageFooterComponent,
            protection: Unprotected,
            optimizedForMobile: true,
            customBackgroundColor: 'rgb(0 118 140)',
        },
        path: 'sign-up',
    },
    {
        canActivate: [IncompatibleBrowserGuard],
        component: DemoRequestComponent,
        data: {
            title: 'Demo request',
            fullWidth: true,
            headerComponent: LandingPageTopBarComponent,
            headerClass: 'landing-page-header',
            footerComponent: LandingPageFooterComponent,
            protection: Unprotected,
            optimizedForMobile: true,
            customBackgroundColor: 'rgb(0 118 140)',
        },
        path: 'demo-request',
    },
]

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)],
})
export class LandingPageRoutingModule {}
